export default __webpack_public_path__ + "static/media/training-image-02.57ffa5d3.jpg";